import React, { useEffect, useState } from 'react';
import Intro from './components/Intro';
import CaseStudyPage from './components/CaseStudyPage';
import { getCaseStudy } from './data/caseStudies';
import './styles.css';

// "/case-studies/<id>" shows that case study; every other path shows the portfolio.
const caseStudyIdFromUrl = () => {
    const [section, id] = window.location.pathname.split('/').filter(Boolean);
    return section === 'case-studies' ? id : null;
};

function App() {
    const [caseStudyId, setCaseStudyId] = useState(caseStudyIdFromUrl);

    // Re-read the URL on back/forward and on in-app Link clicks (see components/Link.js).
    useEffect(() => {
        const onNavigate = () => setCaseStudyId(caseStudyIdFromUrl());
        window.addEventListener('popstate', onNavigate);
        return () => window.removeEventListener('popstate', onNavigate);
    }, []);

    const caseStudy = caseStudyId ? getCaseStudy(caseStudyId) : null;

    return (
        <div className="App">
            {caseStudy ? (
                <CaseStudyPage caseStudy={caseStudy} />
            ) : (
                <div id="intro">
                    <Intro />
                </div>
            )}
        </div>
    );
}

export default App;
